/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const ON_NOTIFY_WORKER_CREATION = gql`
  subscription OnNotifyWorkerCreation($procedureId: ID!) {
    onNotifyWorkerCreation(procedureId: $procedureId) {
      id
      name
      createdAt
      originalWorkerId
      state
      attachments
      owner
      departmentId
      procedureId
      stage
    }
  }
`;
